import { fromJS } from 'immutable';

export const sampleGreetings = fromJS([
    {
        code: 'GREET_001',
        imageURL:
            'https://ak.imgag.com/imgag/product/unifiedbuilder/3555353/productdetail.png',
        altText: 'Laugh. Dream. Wish.',
        className: 'ldw'
    },
    {
        code: 'GREET_002',
        imageURL:
            'https://ak.imgag.com/imgag/product/unifiedbuilder/3555352/productdetail.png',
        altText: 'Enjoy Every Sweet Moment',
        className: 'eesd'
    },
    {
        code: 'GREET_003',
        imageURL:
            'https://ak.imgag.com/imgag/product/unifiedbuilder/3555354/productdetail.png',
        altText: 'So Much Happiness',
        className: 'smh'
    }
]);
